export const STAKING = "staking";
export const UNSTAKING = "unstaking";
export const APPROVE = "approve";
export const CLAIM = "claim";
